<template>
  <div class="editor-wrapper">
    <div :id="toolbarWrap" class="toolbar"></div>

    <div v-if="showHeader" class="header">
      <div class="title">
        <el-input
          v-model="item.title"
          type="text"
          placeholder="请在这里输入标题"
          maxlength="64"
          show-word-limit
        >
        </el-input>
      </div>
      <div class="author">
        <el-input
          v-model="item.author"
          type="text"
          placeholder="作者"
          maxlength="20"
          show-word-limit
        >
        </el-input>
      </div>
    </div>

    <div :id="contentWrap" class="content"></div>
  </div>
</template>
<script>
// 开启 allowJs
import './editorCss'
import E from './editor'

export default {
  name: 'Editor',
  model: {
    props: 'item',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    toolbarWrap: {
      type: String,
      required: true
    },
    contentWrap: {
      type: String,
      required: true
    },
    author: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null,
      html: ''
    }
  },

  watch: {
    html(nV, oV) {
      this.getContent()
    }
  },

  mounted() {
    this.initEditor()
  },

  methods: {
    initEditor() {
      this.editor = new E(`#${this.toolbarWrap}`, `#${this.contentWrap}`)
      // 图片
      this.editor.customConfig.uploadImgShowBase64 = true
      this.editor.customConfig.onchangeTimeout = 50
      this.editor.customConfig.onchange = (html) => {
        // html 即变化之后的内容
        this.html = html
      }
      this.editor.create()
      this.setInitContent()
    },

    setInitContent() {
      if (!this.text) {
        this.editor.txt.html(`<p>正文区域</p>`)
        return
      }
      this.editor.txt.html(this.text)
    },

    // TODO:进行xss过滤, 参考 xss.js
    getContent() {
      let html = this.editor.txt.html()
      this.item.content = html
      this.$emit('update:item', this.item)
    }
  }
}
</script>

<style lang="scss">
.editor-wrapper {
  .toolbar {
    background-color: #f3f4f6;
    padding: 8px 0;
  }
  .content {
    border: 1px solid #f3f4f6;
    height: 400px;
    p {
      margin: 0;
      line-height: 1;
      // color: #cecfd1;
    }
    ul {
      list-style-type: circle!important;
    }
    ol {
      list-style-type: decimal!important;
    }
  }

  .header {
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .title,
  .author {
    .el-input .el-input__inner {
      width: 100%;
      border: none;
    }
  }
  .title {
    .el-input .el-input__inner {
      font-size: 20px;
      font-weight: 500;
    }
  }
  .w-e-text-container .w-e-panel-container {
    top: -110px;
  }
}
</style>
